module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedExtraBold.6d697fa.eot";